import React from 'react';

const Nevada = () => (
  <svg
    width="85"
    height="131"
    viewBox="0 0 85 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.6701 115.25C63.6284 115.412 64.2831 112.884 62.6006 112.687C61.0236 112.771 59.7071 111.476 58.5032 112.687C57.1585 112.954 57.4964 114.201 57.4824 115.25C57.4683 116.059 57.5457 116.447 57.4824 117.299C57.3556 119.108 57.1092 121.066 56.9684 122.931C56.8417 124.642 57.7781 126.001 57.4824 127.536C57.2289 128.832 55.1662 129.036 55.9476 130.606C45.1973 115.574 32.9404 96.9998 21.1341 79.9186C19.2826 77.236 16.9453 74.3563 14.9881 71.2161C14.2348 70.0121 13.6082 68.787 12.4255 67.1183C12.2002 66.7944 11.5877 66.4001 11.4047 66.0974C11.1583 65.7031 11.2005 65.0131 10.8907 64.5624C10.3698 63.802 9.39118 63.3232 8.84205 62.5135C8.51117 62.0207 8.61677 61.4433 8.32812 60.9786C7.36363 59.4226 5.21638 57.078 3.72387 54.8319C1.28095 51.1707 0.119323 50.5863 1.16126 46.1294C1.37247 45.2422 1.97792 44.4466 2.18208 43.5665C2.71009 41.3275 2.75938 38.7646 3.20291 36.9129C6.10344 24.8941 9.73615 12.5937 12.4184 0.560791C35.8128 6.3484 60.0802 11.2629 84.601 15.917C80.8275 36.1173 77.4623 57.6553 73.3368 77.8697C72.0273 84.298 71.4359 91.008 70.2673 97.3237C69.69 100.443 68.8029 103.442 68.2186 106.54C67.6765 109.504 67.8103 112.785 65.6701 115.25Z"
      fill="#FC374D"
    />
  </svg>
);
export default Nevada;
